import ApiClient from '@/services/apiClient';
import Condition from '@/models/condition';
import Action from '@/models/action';

export default class Scenario {
    id;
    label;
    is_active;
    manager_controllable;
    conditions;
    actions;

    constructor(id = 0, label = "") {
        this.id = id;
        this.label = label;
        this.is_active = true;
        this.manager_controllable = false;
        this.conditions = [];
        this.actions = [];
    }

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Scenario();
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.label = ApiClient.convertToType(data['label'], 'String');
            obj.is_active = ApiClient.convertToType(data['is_active'], 'Boolean');
            // absent from an older server: the scenario stays closed to managers
            obj.manager_controllable = ApiClient.convertToType(data['manager_controllable'], 'Boolean') ?? false;
            obj.conditions = ApiClient.convertToType(data['conditions'], [Condition]);
            obj.actions = ApiClient.convertToType(data['actions'], [Action]);
        }
        return obj;
    }

    toJSON() {
      return {
        label: this.label,
        is_active: this.is_active,
        manager_controllable: this.manager_controllable,
        conditions: this.conditions,
        actions: this.actions,
      };
    }

    clone() {
        if(this.id === 0) {
            return this;
        } else {
            return Scenario.constructFromObject(this);
        }
    }

    update(updatedScenario) {
        Scenario.constructFromObject(updatedScenario, this);
    }

    path(facilityId, hubId) {
        return {path: '/component-edit-scenario', params: {facilityId: facilityId, hubId: hubId, id: this.id}};
    }
}
